import React from 'react';

const BarChart = ({ data, height = 200, title }) => {
  const maxValue = Math.max(...data.map(item => item.value));
  
  return (
    <div className="bg-white rounded-lg p-4 shadow">
      {/* Fixed Title Section with ample padding */}
      <div className="mb-8">
        {title && <h3 className="font-medium">{title}</h3>}
      </div>
      
      {/* Chart Area - now in a separate div with fixed height */}
      <div className="relative pt-8" style={{ height: height + 30 + 'px' }}>
        {/* Bars Container */}
        <div className="absolute bottom-0 left-0 right-0 flex justify-around items-end">
          {data.map((item, index) => (
            <div key={index} className="flex flex-col items-center px-2">
              {/* Bar Label on Top */}
              <div className="text-xs font-medium mb-1">{item.value}</div>
              
              {/* The Bar itself */}
              <div 
                className="rounded-t w-12" 
                style={{ 
                  height: `${(item.value / maxValue) * (height - 40)}px`,
                  backgroundColor: item.color || '#3B82F6'
                }}
              ></div>
              
              {/* X-Axis Label */}
              <div className="text-xs text-gray-600 mt-2">{item.label}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BarChart;